import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import extractText from 'flarum/common/utils/extractText';

/**
 * Convivencia / Privacidad en el SPA — el gemelo cliente de `Umbral\Comunidad\Content\LegalPage`.
 *
 * Existe por la misma razón que `N8nChilePage`: el HTML server-side es el contenido de verdad,
 * pero en cuanto Mithril monta, una ruta que el router no conoce se convierte en la pantalla de
 * «no encontrado». Con estas dos clases, entrar por el pie (carga completa) y navegar dentro de
 * la SPA muestran exactamente lo mismo.
 *
 * LAS SECCIONES SE DESCUBREN — ver el bloque largo de `Content/LegalPage.php`. Aquí se usa el
 * mismo contrato del traductor (una clave sin traducción se devuelve tal cual), de modo que el
 * locale es la ÚNICA fuente de cuántas secciones hay y qué dicen.
 */
export abstract class LegalPage extends Page {
  /** Tope de seguridad del bucle; espeja `LegalPage::MAX_SECTIONS` de PHP. */
  static MAX_SECTIONS = 20;

  /** Prefijo de las claves de locale. */
  abstract key(): string;

  oninit(vnode: any) {
    super.oninit(vnode);

    app.setTitle(extractText(this.t('meta_title')));
    app.setTitleCount(0);
  }

  view() {
    return (
      <div className="CmLegal-container container">
        <div className="CmLegal" data-cm-legal={this.key()}>
          <h1 className="CmLegal-title">{this.t('title')}</h1>
          <p className="CmLegal-intro">{this.t('intro')}</p>
          <p className="CmLegal-updated">{this.t('updated')}</p>

          {this.sections().map((section) => (
            <section className="CmLegal-section">
              <h2>{section.title}</h2>
              <p>{section.body}</p>
            </section>
          ))}
        </div>
      </div>
    );
  }

  sections(): Array<{ title: any; body: any }> {
    const out: Array<{ title: any; body: any }> = [];

    for (let i = 1; i <= LegalPage.MAX_SECTIONS; i++) {
      const titleKey = this.fullKey(`s${i}_title`);
      const title = app.translator.trans(titleKey);

      // `extractText` porque `trans` devuelve un vnode en cuanto la traducción lleva marcado;
      // comparar el vnode con la cadena de la clave nunca daría igual y el bucle no pararía
      // hasta MAX_SECTIONS, pintando 12 secciones vacías.
      if (extractText(title) === titleKey) break;

      out.push({ title, body: this.t(`s${i}_body`) });
    }

    return out;
  }

  t(key: string) {
    return app.translator.trans(this.fullKey(key));
  }

  fullKey(key: string) {
    return `umbral-comunidad.forum.${this.key()}.${key}`;
  }
}

/**
 * Dos subclases y no un atributo de ruta: `app.routes[name] = { path, component }` no acepta
 * `attrs` propios, y depender de que el resolver por defecto del core inyecte `routeName` sería
 * atarse a un detalle interno de Flarum que ninguna spec vigila.
 */
export class ConvivenciaPage extends LegalPage {
  key() {
    return 'convivencia';
  }
}

export class PrivacidadPage extends LegalPage {
  key() {
    return 'privacidad';
  }
}
